import * as React from "react";

import BarGraph from "../../../common/DataViz/bar.Component";
import { StyledCard } from "./PerformanceGraph.styles";

interface IProps {
  data?: any;
  selectedCourse?: string;
  completedLessons?: any;
  isParent?: boolean;
  isSchool?: boolean;
  isCourseDetails?: boolean;
  isTeacher?: boolean;
}

class PerformanceGraph extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public renderStudentGraph() {
    const { data, selectedCourse, completedLessons } = this.props;
    const barGraphData = completedLessons.map((lesson) => {
      return {
        lesson: lesson.Title,
        score: lesson.BestScore,
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    if (!selectedCourse) {
      return null;
    }

    return (
      <StyledCard>
        <h2 className="title">Lesson Scores</h2>
        <h5>Your average progress in each pathway</h5>
        <BarGraph bottomLabel="-" realData={barGraphData} />
        {/* <button className="button blue-button">
          Learn more about this graph
        </button> */}
      </StyledCard>
    );
  }

  public renderParentSchoolGraph() {
    const { data, selectedCourse } = this.props;
    const courses = data.CoursesAvailable;
    const barGraphData = courses.map((course) => {
      return {
        course: course.Name.split(" ")[0],
        score: course.AverageScore,
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    if (!selectedCourse) {
      return null;
    }

    return (
      <StyledCard>
        <h2 className="title">Courses Performance</h2>
        <h5>Average students scores in each course</h5>
        <BarGraph
          realData={barGraphData}
          indexBy="course"
          bottomLabel="Course"
          labelNoRotate={true}
        />
      </StyledCard>
    );
  }

  public renderParentSchoolCourseGraph() {
    const { data } = this.props;
    const barGraphData = data.Lessons.map((lesson) => {
      return {
        lesson: lesson.LessonIdentifier,
        score: lesson.AverageScore,
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    return (
      <StyledCard>
        <h2 className="title">Pathway Scores</h2>
        <h3 style={{ textAlign: "center" }}>
          Average progress in each pathway
        </h3>
        <BarGraph realData={barGraphData} />
        {/* <button className="button blue-button">
          Learn more about this graph
        </button> */}
      </StyledCard>
    );
  }

  public renderTeacherCourseDetailsGraph() {
    const { data } = this.props;
    const barGraphData = data.lessons.map((lesson) => {
      return {
        lesson:
          lesson.lesson_display_name === "default"
            ? lesson.lesson_name
            : lesson.lesson_display_name,
        score: lesson.avg_score === 0 ? 1 : Math.round(lesson.avg_score),
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    return (
      <StyledCard>
        <h2 className="title">Pathway Scores</h2>
        <h3 style={{ textAlign: "center" }}>
          Average progress in each pathway
        </h3>
        <BarGraph showXAxis={false} realData={barGraphData} />
        {/* <button className="button blue-button">
          Learn more about this graph
        </button> */}
      </StyledCard>
    );
  }

  public renderTeacherCourseGraph = () => {
    const { data } = this.props;
    const barGraphData = data.available_courses.map((lesson) => {
      return {
        course: lesson.course_display_name
          ? lesson.course_display_name
          : lesson.course_name,
        score: lesson.avg_score === 0 ? 1 : Math.round(lesson.avg_score),
        scoreColor: `#${Math.random().toString(16).substr(2, 6)}`,
      };
    });

    return (
      <StyledCard>
        <h2 className="title">Course Scores</h2>
        <h3 style={{ textAlign: "center" }}>Average progress in each course</h3>
        <BarGraph
          realData={barGraphData}
          indexBy="course"
          bottomLabel="Course"
          labelNoRotate={true}
          showXAxis={false}
        />
        {/* <button className="button blue-button">
          Learn more about this graph
        </button> */}
      </StyledCard>
    );
  };

  public render() {
    const { isParent, isSchool, isTeacher, isCourseDetails } = this.props;

    if (isCourseDetails && isParent) {
      return this.renderParentSchoolCourseGraph();
    }
    if ((isCourseDetails && isTeacher) || (isCourseDetails && isSchool)) {
      return this.renderTeacherCourseDetailsGraph();
    }
    if (isParent) {
      return this.renderParentSchoolGraph();
    }
    if (isTeacher || isSchool) {
      return this.renderTeacherCourseGraph();
    }

    // if (!isSchool && !isTeacher) {return this.renderStudentGraph();}

    return ''
  }
}

export default PerformanceGraph;



// WEBPACK FOOTER //
// ./src/components/DataCentre/PerformanceGraph/PerformanceGraph.tsx